import { normalizeCurrencySign } from '../../../utils/currencyConversion';

/**
 * Currency string → display symbol for bot chat UI.
 *
 * Providers hand us currency in two shapes: flights/hotels/packages send a sign
 * ('$', '€', '₪'); events/attractions send an ISO code ('EUR', 'USD', 'ILS').
 * Reuse the app's canonical `normalizeCurrencySign` so both collapse to the same
 * symbol, falling back to the raw value for any currency the map doesn't know
 * (mirrors the normal EventCard behaviour). Empty/nullish input → ''.
 */
export function formatBotCurrency(currency?: string | null): string {
  if (!currency) {
    return '';
  }
  return normalizeCurrencySign(currency) ?? currency;
}
